import styled from 'styled-components'

export const Container = styled.div`
    background-color: rgb(255, 255, 255);
`
